import apiProvincesListCall from 'apps/investcore/apiCalls/provinces/list';
import apiCall from 'apps/investcore/apiCalls/wards';
import { DynamicFilterForm, FilterFieldConfig } from 'common/dynamic-filter-form';
import { useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';

const WardFilterForm = props => {
  const { data: provinces, load: loadProvinces } = useFetchApiList(apiProvincesListCall, {
    resourceName: 'data',
  });

  useEffect(() => {
    loadProvinces({ address_version: 'v2', page_size: 99 });
  }, []);

  const filterFields: FilterFieldConfig[] = [
    {
      name: 'province_id',
      type: 'select',
      label: 'Province',
      options: (provinces || []).map(p => ({ value: p.id, label: p.name })),
    },
  ];

  return <DynamicFilterForm fields={filterFields} {...props} />;
};

export const WardListPage = () => (
  <ListPage
    title="All Wards"
    description="All wards for new address version"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={WardFilterForm}
  />
);

export const WardDetailPage = props => (
  <DetailPage
    title="Ward"
    apiCall={apiCall}
    listUrl={`/admin/wards`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);
